import * as _colors from './colors.module.scss';

export default _colors as unknown as _colors.Styles;
